<arb-base-dialog class="update-dialog" [title]="data.title" [subtitle]="data.subtitle">
  <ng-container content>
    <arb-message class="message" [message$]="httpError$"></arb-message>
    <textarea [formControl]="messageControl" class="deny-textarea"></textarea>
  </ng-container>
  <ng-container actions>
    <button [class.thin]="data.thinButtons" (click)="close(null)" class="action-btn" [color]="data.rejectButtonColor"
            mat-flat-button>
      {{data.rejectButtonText}}
    </button>
    <button [class.thin]="data.thinButtons"
            [disabled]="messageControl.errors"
            (click)="submitMessage()"
            class="action-btn accept"
            mat-flat-button
            [color]="data.acceptButtonColor">
      {{ data.acceptButtonText }}
    </button>
  </ng-container>
</arb-base-dialog>
